import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-657630df")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Pokemon List", -1)
const _hoisted_3 = { class: "home__main-content" }
const _hoisted_4 = { class: "home__pagination" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Previous ")
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_9 = { class: "home__pokemon-cards" }
const _hoisted_10 = { class: "home__pagination" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Previous ")
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Next ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_fa = _resolveComponent("fa")!
  const _component_PokemonCard = _resolveComponent("PokemonCard")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "home__pagination-btn btn btn--primary",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePage(false))),
          disabled: !_ctx.prevPageUrl
        }, [
          _createVNode(_component_fa, { icon: "arrow-left" }),
          _hoisted_6
        ], 8, _hoisted_5),
        _createElementVNode("button", {
          class: "home__pagination-btn btn btn--primary",
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changePage && _ctx.changePage(...args))),
          disabled: !_ctx.nextPageUrl
        }, [
          _hoisted_8,
          _createVNode(_component_fa, { icon: "arrow-right" })
        ], 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pokedex, (pokemon) => {
          return (_openBlock(), _createBlock(_component_PokemonCard, {
            key: pokemon.id,
            pokemon: pokemon
          }, null, 8, ["pokemon"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "home__pagination-btn btn btn--primary",
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePage(false))),
          disabled: !_ctx.prevPageUrl
        }, [
          _createVNode(_component_fa, { icon: "arrow-left" }),
          _hoisted_12
        ], 8, _hoisted_11),
        _createElementVNode("button", {
          class: "home__pagination-btn btn btn--primary",
          type: "button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changePage && _ctx.changePage(...args))),
          disabled: !_ctx.nextPageUrl
        }, [
          _hoisted_14,
          _createVNode(_component_fa, { icon: "arrow-right" })
        ], 8, _hoisted_13)
      ])
    ], 512), [
      [_vShow, !_ctx.isLoading]
    ])
  ]))
}